// extracted by mini-css-extract-plugin
module.exports = {"newsArticleWrapper":"NewsArticle_newsArticleWrapper__wXx-T","site":"NewsArticle_site__11CwM","title":"NewsArticle_title__3HGhk","description":"NewsArticle_description__3P40V"};